export default function tvcQueryParameters({key = '', location = ''}) {
    const data = (new RegExp('(?:\\?|\\&)' + encodeURIComponent(key) + '=([^\\&\\#]*)').exec(location));
    const result = (data && data.length) ? (decodeURIComponent(data[1])) : null;
    return result;
  }